export default __webpack_public_path__ + "static/media/twitter.936cf75c.svg";